import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFAQ, IFAQState } from "./faqModel";
import {
  ActiveInactiveFAQ,
  createFAQ,
  deleteFAQ,
  getAllActiveFAQ,
  getAllFAQ,
  getFAQByID,
  updateFAQ,
} from "./services/faq.services";

const initialState: IFAQState = {
  loading: false,
  formloading: false,
  error: "",
  FAQID: null,
  FAQList: [],
  FAQDetail: {
    ServiceID: null,
    Question: "",
    Answer: "",
    SequenceNo: null,
    IsActive: 1,
  },
};

const faqSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {
    clearFAQDetails: (state) => {
      state.FAQDetail = initialState.FAQDetail;
    },
    setFAQID: (state, action) => {
      state.FAQID = action.payload;
    },
    clearFAQID: (state) => {
      state.FAQID = initialState.FAQID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllFAQ.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllFAQ.fulfilled,
      (state, action: PayloadAction<IFAQ[]>) => {
        state.loading = false;
        state.FAQList = action.payload || [];
      }
    );
    builder.addCase(getAllFAQ.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.FAQList = [];
    });
    builder.addCase(createFAQ.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(createFAQ.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(createFAQ.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateFAQ.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(updateFAQ.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(updateFAQ.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteFAQ.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteFAQ.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteFAQ.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getFAQByID.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(getFAQByID.fulfilled, (state, action: any) => {
      state.formloading = false;
      state.FAQDetail = action.payload;
    });
    builder.addCase(getFAQByID.rejected, (state, action) => {
      state.formloading = false;
      state.FAQDetail = initialState.FAQDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveFAQ.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveFAQ.fulfilled,
      (state, action: PayloadAction<IFAQ[]>) => {
        state.loading = false;
        state.FAQList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveFAQ.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.FAQList = [];
    });
    builder.addCase(ActiveInactiveFAQ.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveFAQ.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveFAQ.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearFAQDetails, clearFAQID, setFAQID } = faqSlice.actions;
export default faqSlice.reducer;
